import React, { useEffect, useState } from "react";
import BlockSkeleton from "../../interfaccia/loading/BlockSkeleton";
import stilePulsanti from "../../interfaccia/stilePulsanti";
import { isAnnullata, messaggioErrore } from "../../modificaProdotti/pagine/kitModa/kitModaApi";

const FINALI = ["COMPLETED", "COMPLETED_WITH_ERRORS", "FAILED"];
const STATI = {
  PENDING: "In attesa", RUNNING: "In corso", COMPLETED: "Completato",
  COMPLETED_WITH_ERRORS: "Completato con errori", FAILED: "Fallito",
};
const ESITI = {
  PENDING: "In attesa", IN_PROGRESS: "In corso", SUCCESS: "Inviato", SKIPPED: "Saltato", ERROR: "Errore",
};

export default function KitModaImportJob({ jobId, api, onAttivo, onNonTrovato }) {
  const [job, setJob] = useState(null);
  const [avviso, setAvviso] = useState("");
  const [filtro, setFiltro] = useState("");
  const [tutti, setTutti] = useState(false);
  useEffect(() => {
    let attivo = true;
    let timer;
    let controller;
    onAttivo(true);
    async function leggi() {
      controller = new AbortController();
      let finale = false;
      try {
        const dati = await api.statoImport(jobId, controller.signal);
        if (!attivo || controller.signal.aborted) return;
        setJob(dati); setAvviso("");
        finale = FINALI.includes(dati.status);
        onAttivo(!finale);
      } catch (error) {
        if (attivo && error?.response?.status === 404) {
          // Job inesistente (es. altro ambiente o storico ripulito): niente polling infinito.
          finale = true;
          onAttivo(false);
          onNonTrovato?.();
        } else if (attivo && !controller.signal.aborted && !isAnnullata(error)) {
          setAvviso(`Stato temporaneamente non disponibile: ${messaggioErrore(error, "Errore di rete")}. Riprovo tra 3 secondi; questo non indica un fallimento del job.`);
        }
      } finally {
        // Si programma la lettura successiva solo dopo la conclusione della precedente.
        if (attivo && !finale) timer = setTimeout(leggi, 3000);
      }
    }
    leggi();
    return () => { attivo = false; clearTimeout(timer); controller?.abort(); };
  }, [jobId, api, onAttivo, onNonTrovato]);

  const items = (job?.items || []).filter(i => !filtro || i.status === filtro);
  const visibili = tutti ? items : items.slice(0, 100);
  return <section className="mv3 pa3 ba bordoColAlt br3" aria-label="Avanzamento import Kit Moda">
    <h3>Avanzamento import</h3>
    <p>Job: {jobId}. Chiudere la pagina non interrompe il job backend.</p>
    {avviso && <p role="status">{avviso}</p>}
    {!job ? <BlockSkeleton height={180} aria-label="Lettura avanzamento job" /> : <>
      <p role="status">Stato: {STATI[job.status] || job.status}</p>
      <progress className="w-100" aria-label="Kit elaborati" max={job.totale || 1} value={job.elaborati || 0} />
      <p>Elaborati: {job.elaborati} / {job.totale} · Inviati: {job.inviati} · Saltati: {job.saltati} · Errori: {job.errori} · Composizioni salvate: {job.composizioniSalvate}</p>
      {job.messaggio && <p>{job.messaggio}</p>}
      <label>Filtra esito <select value={filtro} onChange={e => { setFiltro(e.target.value); setTutti(false); }}>
        <option value="">Tutti</option>{Object.entries(ESITI).map(([value, label]) => <option key={value} value={value}>{label}</option>)}
      </select></label>
      <p>Visibili {visibili.length} di {items.length} esiti. Errori: {job.errori}; saltati: {job.saltati}.</p>
      <div className="overflow-x-auto"><table className="collapse w-100" aria-label="Esiti import Kit Moda">
        <thead><tr className="tl bb bordoColAlt">{["EAN", "codVS / tripletta", "Esito", "Messaggio"].map(t => <th key={t} className="pa2">{t}</th>)}</tr></thead>
        <tbody>{visibili.map((item, i) => <tr key={item.tripletta || i}
          className={`bt bordoColAlt ${["ERROR", "SKIPPED"].includes(item.status) ? "b sfondoColChiaro" : ""}`}>
          <td className="pa2">{item.ean}</td><td className="pa2">{item.codVS}<small className="db">{item.tripletta}</small></td>
          <td className="pa2">{ESITI[item.status] || item.status}</td><td className="pa2">{item.messaggio}</td>
        </tr>)}</tbody>
      </table></div>
      {items.length > 100 && <button type="button" className={stilePulsanti.buttonClassesWhite}
        onClick={() => setTutti(!tutti)}>{tutti ? "Mostra primi 100 esiti" : "Mostra tutti gli esiti"}</button>}
    </>}
  </section>;
}
